import { CircularProgress, Container } from '@material-ui/core'
import React from 'react'


export default props => {
    return(
        <Container>
            <CircularProgress color="primary" />
        </Container>
    )
}